export function index(){
    if(document.getElementById('firstview')){
        let swiperEl = document.getElementById('firstview');
        const plam = {
			slidesPerView: 1,
			spaceBetween: 0,
			effect: 'fade',
			speed: 2000,
			loop: true,
            simulateTouch: false,
			autoplay: {
				delay: 6000,
				disableOnInteraction: false,
			},
            pagination: {
                el: '.swiper-pagination',
            },
            on: {
                resize: function(){
                    swiperEl.destroy(false,true);
                    swiperEl = new Swiper("#firstview",plam);
                }
            },
        };
        swiperEl = new Swiper('#firstview' , plam);
    }
}